import React from 'react'
import { useNavigate } from "react-router-dom";
import './demoexpired.css'
const Demoexpired = () => {

      const navigate = useNavigate();

  const handleTryAnotherEmail = () => {
    navigate("/free-trial");
  };


  return (
     <div className="trial-expired-page">

      <div className="trial-expired-card">

        <img
          src="/oops.png"
          alt="Trial expired"
          className="trial-expired-illustration"
        />

        <h1 className="trial-expired-title">
          Your Trial Has Expired!!
        </h1>

        <p className="trial-expired-description">
          Your free trial has ended and the
          <br />
          account wasn't upgraded.
        </p>

        <p className="trial-expired-deleted">
          Your trial data has now been deleted.
        </p>

        <button
          className="trial-expired-btn"
          onClick={handleTryAnotherEmail}
        >
          Try With Another Email →
        </button>

      </div>

    </div>
  )
}

export default Demoexpired